import ImagesMarketingMarketingWinBottleSignUpWebp from '@/public/images/marketing/marketing-win-bottle-sign-up.webp';

export { ImagesMarketingMarketingWinBottleSignUpWebp };
